<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @cancel="handleCancel"
    okText="确定"
    cancelText="关闭"
  >
    <iot-alert-whitelist-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></iot-alert-whitelist-form>
  </j-modal>
</template>

<script>
import IotAlertWhitelistForm from './IotAlertWhitelistForm'
export default {
  name: 'IotAlertWhitelistModal',
  components: {
    IotAlertWhitelistForm
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false
    }
  },
  methods: {
    add(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add(record)
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
